export const SEND_EDOK_FORM_FAILURE = 'SEND_EDOK_FORM_FAILURE';

export const sendEdokFormFailure = error => ({
    type: SEND_EDOK_FORM_FAILURE,
    payload: error,
    error: true,
});
